import { Messages } from '@openreplay/tracker';
function createGraphqlMiddleware() {
    return (app) => {
        if (app === null) {
            return (_1, _2, _3, result) => result;
        }
        return (operationKind, operationName, variables, result, duration = 0) => {
            try {
                app.send(Messages.GraphQL(operationKind, operationName, JSON.stringify(variables), JSON.stringify(result), duration));
            }
            catch (e) {
                console.error(e);
            }
            return result;
        };
    };
}
export default createGraphqlMiddleware;
